import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appointableQueryKeys } from "./appointableQueryKeys";

export function useAppointableDisable({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (appointableId: number) => {
      return (await api.appointableApi.disable(appointableId)).data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointableQueryKeys.all() });
    },
  });
}
